import React, { useEffect, useState} from 'react';
import classes from './Video.module.scss';
import { getCdnPath } from '../../../utils/helpers';

const Video = props => {
    const { path, format, autoPlay, muted, showControls, play, onPlay, onPaused, onEnded, onCanPlayThrough, onLoadedData} = props;
    const type  = "video/" + format;
    const style = props.style?? {width:"100%", height: '100%'};

    useEffect(() => {

        const videoplayer = document.getElementById("videoplayer");
        videoplayer.controls = showControls;
        videoplayer.onplay = () => {
            onPlay();
        }

        videoplayer.onloadeddata = () => {
            onLoadedData();
        }

        videoplayer.onpause = () => {
            onPaused();
        }

        if(play) {
            videoplayer.play();            
        } else {
            videoplayer.pause();
        }
        
        videoplayer.oncanplaythrough = onCanPlayThrough;

        videoplayer.onended = function() {
            if(typeof document !== "undefined" && window.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) { /* Safari */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE11 */
                    document.msExitFullscreen();
                }
            }            
            onEnded();
        }
        
    });

    return autoPlay ? 
            <video id="videoplayer" style={style} autoPlay muted playsInline>
                <source src={getCdnPath(path) + "#t=0.001"} type={type}/>
                Your browser does not support the video tag.
            </video> : 
            <video id="videoplayer" style={style} playsInline>
                <source src={getCdnPath(path) + "#t=0.001"} type={type}/>
                    Your browser does not support the video tag.
            </video> 
}


export default Video;
